import React, { useState } from 'react';
import { uploadFile } from './AttachmentService';
import { Button } from '@mui/material';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

interface Props {
  uploadLoadedFileData: (
    filename: string,
    contentType: string,
    size: string,
  ) => void;
}

const FileUpload: React.FC<Props> = ({ uploadLoadedFileData }) => {
  console.log('uploadLoadedFileData:', uploadLoadedFileData);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const onFileUpload = () => {
    if (!selectedFile) {
      console.error('No file selected');
      return;
    }

    if (selectedFile.size > 25 * 1024 * 1024) {
      // 10MB limit
      notify('File is too large. Please upload a file smaller than 10MB.');
      return;
    }

    const formData = new FormData();

    console.log(selectedFile);
    console.log(selectedFile.type);
    console.log(selectedFile.name);
    console.log(selectedFile.size);

    formData.append('file', selectedFile);
    formData.append('type', 'subscription'); // MIME type (e.g., image/png, application/pdf)
    formData.append('identifier', 'TEST'); // file name (e.g., document.pdf)

    // Log for debugging
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    uploadFile(formData)
      .then((response) => {
        console.log(
          'uploadLoadedFileData response filePath:',
          response.data.filePath,
        );
        console.log(
          'uploadLoadedFileData response contentType:',
          response.data.contentType,
        );
        console.log('uploadLoadedFileData response size:', response.data.size);

        uploadLoadedFileData(
          response.data.filePath,
          response.data.contentType,
          response.data.size,
        );
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        notify(extractErrorMessage(error));
      });
  };

  return (
    <div>
      <h3>Select and upload a file</h3>
      <input type="file" onChange={onFileChange} />
      <Button onClick={onFileUpload}>Upload</Button>
    </div>
  );
};

export default FileUpload;
